export const ApiRoute =
  process.env.REACT_APP_API_URL || "https://api.restaurantmorvarid.ir";
